<ng-select id="paymentMethodSelect" name="paymentMethods" [ngModelOptions]="{ standalone: true }" [items]="availablePayments" bindValue="id" bindLabel="name" [multiple]="true" 
  [closeOnSelect]="false" [clearable]="true" [searchable]="true" [(ngModel)]="selectedPaymentMethods" (clear)="onClearAll()"
  [placeholder]="paymentPlaceholder" (ngModelChange)="onPaymentChange($event)" #paymentMethodSelect
  [ngClass]="{ 'ng-payment-options': source === 'mbilling',
    'ng-payment-options1': source === 'cloudpos',
    'ng-payment-options2': source === 'invoice',
    'error-border-pay': selectedPaymentMethods?.length == 0 && source === 'mbilling' && formSubmit,
    'invalid-form-control-pay': selectedPaymentMethods?.length == 0 && source === 'cloudpos' && formSubmit,
    'error-border-pay1': selectedPaymentMethods?.length == 0 && source === 'invoice' && formSubmit
  }">

  <ng-template ng-header-tmp>
    <div class="payment-option select-all" (mousedown)="$event.stopPropagation()" (click)="toggleSelectAll();$event.stopPropagation()">
      <input type="checkbox" [checked]="isAllSelected()" />
      <strong class="select-all">Select All</strong>
    </div>
  </ng-template>  

  <!-- Dropdown options -->
  <ng-template ng-option-tmp let-item="item">
    <div class="payment-option">
      <input type="checkbox" [checked]="selectedPaymentMethods?.includes(item.id)" tabindex="-1" readonly/>
      <img class="payment-icon" [src]="item.icon" [alt]="item.name"/>
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
</ng-select>